<div class="content-header" [class.content-header__sub]="sub">
    @if (custom) {
        <ng-content></ng-content>
    } @else {
        @if (icon) {
            <div class="mobile-nav">
                @switch (icon) {
                    @case ("menu") {
                        <kui-icon kui-action name="bars" (click)="action.emit('menu')"></kui-icon>
                    }
                    @case ("back") {
                        <kui-icon kui-action name="chevron-left" (click)="action.emit('back')"></kui-icon>
                    }
                    @case ("close") {
                        <kui-icon kui-action name="times" (click)="action.emit('close')"></kui-icon>
                    }
                }
            </div>
        }

        <ng-content select="[kui-content-header-custom-content]"></ng-content>
        <ng-content select="[kui-content-header-title]"></ng-content>
        <div class="tab-mount">
            <ng-content select="kui-tab-bar"></ng-content>
        </div>

        <!-- TITLE -->
         @if (titleTemplate) {
            <div kui-content-header-title>
                <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
            </div>
        }  @else if (title) {
            <div kui-content-header-title [class.d-flex]="isDesktop()">
                <div (click)="_title.click && _title.click()" [class.pointer]="_title.click">
                    @if (_title?.iconName && _title?.iconPosition === "prefix") {
                        <kui-icon class="mr-1" size="sm" [name]="_title?.iconName"> </kui-icon>
                    }
                    {{ _title?.value }}
                    @if (_title?.iconName && _title?.iconPosition === "sufix") {
                        <kui-icon class="ml-1" [name]="_title?.iconName"> </kui-icon>
                    }
                </div>
            </div>
        }

        @if (tabMode() === "inlineTabs" && !!tabs?.length) {
            <div class="tab-mount">
                <kui-tab-bar
                    [items]="tabs"
                    [closeButton]="closeableTabs"
                    [selected]="activeTab?.id"
                    [draggable]="draggableTabs"
                    (reorder)="dragTab($event)"
                    (selection)="selectTab($event)"
                    (close)="closeTab($event)"
                >
                </kui-tab-bar>
            </div>
        }
        <div class="icon-mount">
            @if (!!actions()?.length) {
                <kui-content-header-actions>
                    <!-- ACTIONS -->
                     @for (action of actions(); track action.id) {
                        @if (action.menu || action.template) {
                            <kui-dropdown class="pl-1"
                                [style]="'none'"
                                [menu]="action.menu"
                                [customContent]="action.template"
                                [customContentContext]="action.templateContext">
                                
                                <div class="d-flex" kui-action>
                                    <kui-icon 
                                        [name]="action.icon"
                                        [class.active]="action.active"
                                        [title]="action.name"></kui-icon>

                                    @if (['text', 'both'].includes(action.show)) {
                                        <span kui-action class="ml-1 align-items-center">
                                            {{ action.name }}
                                        </span>
                                    }
                                </div>
                            </kui-dropdown>
                        } @else {
                            <kui-icon kui-action
                                class="pl-1"
                                [class.active]="action.active"
                                [name]="action.icon"
                                [title]="action.name"
                                (click)="action.click()">
                            </kui-icon>
                            
                            @if (['text', 'both'].includes(action.show)){
                                <span kui-action (click)="action.click()">{{ action.name }}</span>
                            }
                        }
                    }
                </kui-content-header-actions>
            }

            <ng-content select="kui-content-header-actions"></ng-content>
        </div>
    }
</div>

@if (tabMode() === "separateTabs" && !!tabs?.length) {
    <kui-tab-bar
        [items]="tabs"
        [closeButton]="closeableTabs"
        [selected]="activeTab?.id"
        [draggable]="draggableTabs"
        (reorder)="dragTab($event)"
        (selection)="selectTab($event)"
        (close)="closeTab($event)"
        [class.mobile-tabs]="!isDesktop() && !displayTitleAndTabs()"
        [class.titleAndTabsPresent]="displayTitleAndTabs()"
    >
    </kui-tab-bar>
}
